// components/sections/About.js
import React from 'react';
import styled from 'styled-components';
import Container from '../common/Container';
import { SectionTitle, SectionSubtitle } from '../common/SharedStyles';
import Button from '../common/Button';

const AboutWrapper = styled.section`
  background: var(--background-secondary);
  padding: 8rem 0;
  width: 100%;
  display: flex;
  align-items: center;
  min-height: 80vh;

  @media (max-width: 576px) {
    width: 100%;
    box-sizing: border-box;
    overflow-x: hidden;
  }
`;

const AboutGrid = styled.div`
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 4rem;
  align-items: center;

  @media (max-width: 768px) {
    grid-template-columns: 1fr;
  }
`;

const Stats = styled.div`
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  gap: 2rem;
  margin-top: 2rem;

  @media (max-width: 768px) {
    grid-template-columns: 1fr;
    gap: 1.5rem;
  }
`;

const StatItem = styled.div`
  text-align: center;

  .number {
    font-size: 2.5rem;
    font-weight: 700;
    color: var(--accent-primary);
    margin-bottom: 0.5rem;
  }

  .label {
    color: var(--text-secondary);
  }
`;

const TeamGrid = styled.div`
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  gap: 1.5rem;
`;

const TeamMember = styled.div`
  text-align: center;

  img {
    width: 120px;
    height: 120px;
    border-radius: 50%;
    margin-bottom: 1rem;
  }

  .name {
    font-weight: 600;
    margin-bottom: 0.5rem;
  }

  .position {
    color: var(--text-secondary);
    font-size: 0.9rem;
  }
`;

const About = () => {
    return (
        <AboutWrapper id="about">
            <Container>
                <SectionTitle>About Signage</SectionTitle>
                <SectionSubtitle>
                    Supporting the hardworking sign manufacturers who keep businesses running
                </SectionSubtitle>

                <div style={{ textAlign: 'center', maxWidth: '800px', margin: '0 auto' }}>
                    <p style={{ fontSize: '1.1rem', lineHeight: '1.8', marginBottom: '2rem', marginTop: '2rem' }}>
                        Founded in 2025, Signage was built to solve the problems that take time, money, and focus away from sign manufacturers. 
                        We give you fast answers to the questions that slow down your productivity —like pricing materials, quoting jobs, and tracking margins—so you don't have to dig for them yourself. 
                        We do the heavy lifting behind the scenes so you can focus on saving more money, cutting down wasted time, and running your shop more efficiently.
                        You manufacture for others — we manufactured this for you.
                    </p>

                    <Stats className="stats-grid">
                        <StatItem>
                            <div className="number">24/7</div>
                            <div className="label">Support</div>
                        </StatItem>
                        <StatItem>
                            <div className="number">100%</div>
                            <div className="label">Customer Satisfaction</div>
                        </StatItem>
                        <StatItem>
                            <div className="number">$500+</div>
                            <div className="label">Avg $$$ Saved</div>
                        </StatItem>
                    </Stats>
                </div>
            </Container>
        </AboutWrapper>
    );
};

export default About;
